import store from "../../store";
import axios from "axios";
import { showHideLoader } from "../../store/Loader/slice";
import {  loginResponse , accessTokenResponse} from "../../store/Auth/slice";
import { clearAdmin } from "../../utils/Auth";
import { showSnackMsg } from "../../utils/Helpers";
import messages from "../../assets/locales/messages";
import {accessToken} from "../../network/apis/auth";
import {setAdminStorage} from "../../utils/Auth";

export const isHandlerEnabled = (config = {}) => {
  return Object.prototype.hasOwnProperty.call(config, "handlerEnabled") &&
    !config.handlerEnabled
    ? false
    : true;
};

// This is used to handle remove loader only if all pending requests are resolved
let numberOfAjaxCAllPending = 0;

// Token refresh handling
let refreshSubscribers = [];
let isRefreshing = false;

const onRrefreshed = (token) => {
  refreshSubscribers.forEach(cb => cb(token));
  refreshSubscribers = [];
};

export const requestHandler = (request) => {
  numberOfAjaxCAllPending++;
  if (isHandlerEnabled(request)) {
    // show loader if not showing skeleton
    const state = store.getState();
    !Object.values(state.loader.skeletonObject).some((val) => val) &&
      store.dispatch(showHideLoader(true));
    addRequestHeaders(request);
  }
  return request;
};

export const successHandler = (response) => {
  numberOfAjaxCAllPending--;
  if (isHandlerEnabled(response)) {
    if (numberOfAjaxCAllPending === 0 && store.getState().upload.isUploadingFiles === false) {
      store.dispatch(showHideLoader(false));
    }
  }
  return response;
};

export const errorHandler = async (error) => {
  const locale = localStorage.getItem("locale");
  const originalRequest = error.config;

  if (error.message === "Network Error") {
    showSnackMsg(locale ? messages[locale].shared.networkError : error.message);
  }
  
  numberOfAjaxCAllPending--;
  if (isHandlerEnabled(originalRequest)) {
    if (numberOfAjaxCAllPending === 0) {
      store.dispatch(showHideLoader(false));
    }
  }

  if (error.response?.status === 401) {
    if (
      originalRequest?.url === "/sessions/refresh_access_token" ||
      originalRequest?.url === "/sessions"
    ) {
      store.dispatch(loginResponse({}));
      clearAdmin();
      return Promise.reject(error);
    }

    if (!originalRequest._retry) {
      originalRequest._retry = true;
      if (isRefreshing) {
        return new Promise((resolve) => {
          refreshSubscribers.push((token) => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            resolve(axios(originalRequest));
          });
        });
      }

      isRefreshing = true;

      try {
        const { data } = await accessToken();
        const adminData = store.getState().auth.admin;

        store.dispatch(accessTokenResponse({
          ...adminData,
          auth_token: data.auth_token,
        }));
        const isRememberMe = !!localStorage.getItem("admin");
        setAdminStorage(
          { ...adminData, auth_token: data.auth_token },
          isRememberMe ? "local" : "session"
        );
        
        if (adminData) {
          // Update axios defaults
          axios.defaults.headers.common['Authorization'] = `Bearer ${data.auth_token}`;
          originalRequest.headers['Authorization'] = `Bearer ${data.auth_token}`;
          
          // Process any queued requests with the new token
          onRrefreshed(data.auth_token);
          
          // Retry the original request with the new token
          return axios(originalRequest);
        } else {
          throw new Error('No admin data found');
        }
      } catch (refreshError) {
        showSnackMsg(refreshError.response?.data?.message)
        store.dispatch(loginResponse({}));
        clearAdmin();
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }
  }

  return Promise.reject({ ...error });
};

const addRequestHeaders = (request) => {
  if (request.url.includes("qualify_from_sheet")) {
    request.headers["Content-Type"] = "multipart/form-data";
  }
  // authorization
  const admin =
    JSON.parse(localStorage.getItem("admin")) ||
    JSON.parse(sessionStorage.getItem("admin"));
  const token = admin?.auth_token;
  if (token) {
    request.headers["Authorization"] = `Bearer ${token}`;
    // no expire token: Uncomment in local development
    // request.headers[
    //   "Authorization"
    // ] = `Bearer eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJ0eXBlIjoiQWRtaW4iLCJuYW1lc3BhY2UiOiJBZG1pblBvcnRhbCIsImRldmljZV9pZCI6ImFiYyIsImV4cCI6NDg2NTA2NzI0Mn0.a-86OzbAprmDkhJqPV17TYqMzBT6c6l6C5AOYiBcKh0`;
  }
  // localization
  const locale = localStorage.getItem("locale") || "en";
  if (locale) {
    request.headers["Accept-Language"] = locale;
  }
};
